import {
  safeJoin,
  safeLength,
  safeLowercase,
  safeNumber,
  safeSubstring,
  safeSum,
  safeToMillis,
  safeTrim,
} from '@procuros/transformer/functions';
import jsonata from 'jsonata';

import type { Expression } from 'jsonata';

/**
 * The `safe*` implementations come straight from `@procuros/transformer/functions`
 * (the same barrel `@procuros/datachecks` consumes), so portal-evaluated expressions
 * behave identically to datachecks. The transformer does not export a registrar that
 * binds them to a JSONata instance, so the registration glue below — the JSONata
 * signature strings and the `registerFunction` loop — lives here. The signatures
 * mirror the transformer's own internal registrations.
 */
const customFunctions: Array<{ name: string; implementation: (...args: Array<any>) => unknown; signature: string }> = [
  { name: 'safeNumber', implementation: safeNumber, signature: '<j?:n?>' },
  { name: 'safeSum', implementation: safeSum, signature: '<j?:n?>' },
  { name: 'safeSubstring', implementation: safeSubstring, signature: '<j?nn?:s?>' },
  { name: 'safeTrim', implementation: safeTrim, signature: '<j?:s?>' },
  { name: 'safeToMillis', implementation: safeToMillis, signature: '<j?:n?>' },
  { name: 'safeLength', implementation: safeLength, signature: '<j?:n?>' },
  { name: 'safeLowercase', implementation: safeLowercase, signature: '<j?:s?>' },
  { name: 'safeJoin', implementation: safeJoin, signature: '<j?s?:s?>' },
];

export const registerCustomFunctions = (expression: Expression): Expression => {
  for (const { name, implementation, signature } of customFunctions) {
    expression.registerFunction(name, implementation, signature);
  }
  return expression;
};

/**
 * Drop-in replacement for `jsonata(expression)` that registers the transformer's `safe*`
 * custom functions, so expressions authored for datachecks evaluate identically here.
 */
export const createJsonata = (expression: string): Expression => registerCustomFunctions(jsonata(expression));
